var _path, _path2, _path3, _circle, _circle2, _rect, _rect2, _rect3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLines(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1320,
    height: 420,
    viewBox: "0 0 1320 420",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1321 49C991.4 -55 947 21 849 168C751 315 261 221.333 1 139",
    stroke: "url(#paint0_linear_9_27)",
    strokeOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1321 111.024C991.4 7.02359 938 1.13933 849 230.024C760 458.908 217 324.907 1 201.024",
    stroke: "url(#paint1_linear_9_27)",
    strokeOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1321 171.33C991.4 67.3301 939 -31.6463 849 290.33C759 612.307 128 226.306 1 261.33",
    stroke: "url(#paint2_linear_9_27)",
    strokeOpacity: 0.3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 952.5,
    cy: 39.5,
    r: 3.5,
    fill: "#37314E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 280.5,
    cy: 208.5,
    r: 3.5,
    fill: "#37314E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1004.05,
    y: 65.6252,
    width: 8.06322,
    height: 8.21532,
    transform: "rotate(17.1429 1004.05 65.6252)",
    stroke: "#1B1730"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 291.047,
    y: 308.625,
    width: 8.06322,
    height: 8.21532,
    transform: "rotate(17.1429 291.047 308.625)",
    stroke: "#1B1730"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 845.047,
    y: 228.625,
    width: 8.06322,
    height: 8.21532,
    transform: "rotate(17.1429 845.047 228.625)",
    stroke: "#1B1730"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_27",
    x1: 1173,
    y1: 4.00212,
    x2: 1.00065,
    y2: 135.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBC8FF",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215587,
    stopColor: "#DBC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418299,
    stopColor: "#DBC8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.600811,
    stopColor: "#DBC8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769791,
    stopColor: "#DBC8FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBC8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_27",
    x1: 1173,
    y1: 66.0276,
    x2: 1.00092,
    y2: 197.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBC8FF",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215587,
    stopColor: "#DBC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418299,
    stopColor: "#DBC8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.600811,
    stopColor: "#DBC8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769791,
    stopColor: "#DBC8FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBC8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9_27",
    x1: 1173,
    y1: 126.334,
    x2: 1.00114,
    y2: 257.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBC8FF",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215587,
    stopColor: "#DBC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418299,
    stopColor: "#DBC8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.600811,
    stopColor: "#DBC8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769791,
    stopColor: "#DBC8FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBC8FF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.7113ec4fccfd33b2107ca4e4f9c13be1.svg";
export { ForwardRef as ReactComponent };